<template>
  <div>
    <v-card
      flat
      :loading="loading"
      class="tab-details"
    >
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-card-text>
        <div class="mx-12 text-h6 font-weight-black mt-3 text-c-green">
          {{ local.caseFile.tabHeaders.procedures }}
        </div>

        <v-row class="mx-12">
          <template v-for="(procedure, index) in procedures">
            <v-col
              :key="index"
              cols="4"
            >
              <procedure-card
                :procedure="procedure"
                :is-pega="isPega"
                :period="period"
              ></procedure-card>
            </v-col>
          </template>
          <v-col cols="12">
            <naj-no-data
              :has-data="procedures &&procedures.length > 0"
              :loading="loading"
            ></naj-no-data>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <degree-color-palette></degree-color-palette>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');
import { toHijriDate, getTimePart } from '@/helpers/utils';
import ProcedureCard from '../../../../global/components/cards/procedure-card.vue';
import DegreeColorPalette from '../degree-color-palette';
import { userType } from '@/helpers/enum';

export default {
  name: 'CaseProceduresTab',
  components: {
    ProcedureCard,
    DegreeColorPalette,
  },
  props: {
    caseObjectKey: {
      type: String,
      required: true,
    },
    isPega: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      userType,
      procedures: [],
      loading: false,
      period: 0,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions(['getCaseProcedures', 'getJudicialProcedureExpirationPeriod']),
    toHijriDate,
    getTimePart,
    loadData() {
      const params = {
        objectKey: this.caseObjectKey,
        isPega: this.isPega,
      };
      this.loading = true;
      this.getCaseProcedures(params)
        .then((res) => {
          this.procedures = res.data;
          this.getExpirationPeriod();
        })
        .finally(() => (this.loading = false));
    },
    getExpirationPeriod() {
      this.getJudicialProcedureExpirationPeriod().then(({ data }) => {
        this.period = data;
      });
    },
  },
};

</script>

<style scoped >
</style>